import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/store";
import {
  setPaymentMethod,
  setTIN,
  setVAT,
} from "../../reducer/registrationReducer";
import { setPaymentMethodModal } from "../../reducer/modalReducer";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

function PaymentMethodModal() {
  const dispatch = useDispatch();
  const { paymentMethod } = useSelector(
    (state: RootState) => state.registration
  );
  const { paymentMethodModal } = useSelector((state: RootState) => state.modal);

  const [method, setMethod] = useState<string>(paymentMethod);

  const handleSaveChanges = () => {
    dispatch(setPaymentMethod(method));
    dispatch(setPaymentMethodModal(false));
  };

  const handleCancelEdit = () => {
    dispatch(setPaymentMethodModal(false));
  };

  const handleBackdropClick = (event: any) => {
    if (event.target === event.currentTarget) {
      handleCancelEdit();
    }
  };

  return (
    <div
      className={`fixed z-50 top-0 left-0 w-full h-full items-center justify-center bg-gray-500 bg-opacity-75 ${
        paymentMethodModal ? "flex" : "hidden"
      } `}
      onClick={handleBackdropClick}
    >
      <div className={Classname.modalContent}>
        <div className={Classname.title}>Edit payment method</div>
        <div className="mb-4">Payment method</div>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Method</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={method}
            label="Type"
            className="h-10 mt-2"
            onChange={(e) => setMethod(e.target.value)}
          >
            <MenuItem value="Bank transfer">Bank transfer</MenuItem>
          </Select>
        </FormControl>
        <div className={Classname.justifyEnd}>
          <button onClick={handleCancelEdit} className={Classname.button}>
            Cancel
          </button>
          <button onClick={handleSaveChanges} className={Classname.saveButton}>
            Save changes
          </button>
        </div>
      </div>
    </div>
  );
}

export default PaymentMethodModal;

const Classname = {
  modalContent:
    "bg-white p-6 mx-2 w-full max-w-[500px] rounded shadow-md max-h-[90vh] overflow-scroll",
  title: "font-bold mb-2",
  input: "w-full border border-gray-300 p-2 mt-2 rounded-md h-10 mb-4",
  button: "px-4 py-2 rounded-lg border-blue-500 border",
  saveButton: "ml-2 bg-blue-500 text-white px-4 py-2 rounded-lg",
  justifyEnd: "mt-4 flex justify-end",
};
